<template>

  <div class="user">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <el-form-item label="是否开启" prop="is_coupon">
        <el-switch v-model="form.is_activity"></el-switch>
      </el-form-item>

      <el-form-item label="推荐佣金" prop="invite_price">
        <el-input type='number' v-model="form.invite_price" class="max-w460"></el-input>%
        <div>不作任何计算，推广者前端只是看到</div>
      </el-form-item>

      <el-form-item label="成交佣金" prop="cj_price">
        <el-input type='number' v-model="form.cj_price" class="max-w460"></el-input>%
        <div>不作任何计算，推广者前端只是看到</div>
      </el-form-item>


      <el-form-item label="广告图" prop="setting" >
        <div>
             <el-button icon="el-icon-plus" @click.stop="addBan">添加广告图</el-button>
           </div>

           <table border cellspacing="0" class="mt10" style="border:1px solid #ECEFF7">
             <tr  style="border:1px solid #ECEFF7">
              <th class="w150" style="width: 200px;border:1px solid #ECEFF7">图片</th>
               <th class="w150" style="width: 300px;border:1px solid #ECEFF7">跳转链接</th>
               <th class="w150" style="width: 100px;border:1px solid #ECEFF7">操作</th>
             </tr>
             <tr v-for="(item,index) in form.ban" style="border:1px solid #ECEFF7">

               
              <td>
                <div v-if="item.file_path" class="default-image-box" @click="isAboutLogoUpload = true">
                <div class="image-box">
                  <img :src="item.file_path" 
                  style="width: 200px;height: 100px;"
                  alt="product_default_image">
     
                </div>
              </div>
              <div v-else>
                <div class="img-select" @click="selectImage(index)"><i class="el-icon-plus"></i></div>
              </div>



              </td>
              
              <td class="tc" style="border:1px solid #ECEFF7">
      
                <el-input class="max-w460" placeholder="点击选择你要链接的位置" v-if="item.link" v-model="'链接到' + item.link.type + ' ' + item.link.name" :disabled="true"></el-input>
                <el-input class="max-w460" placeholder="点击选择你要链接的位置" v-if="!item.link" :disabled="true"></el-input>
                <el-button icon="el-icon-link" @click="changeLink(index)">选择链接</el-button>
               </td>
  
               <td class="tc" style="width: 100px;border:1px solid #ECEFF7">
                <a @click="delBan(index)"> 删除</a>
              </td>
             </tr>
           </table>
        
    </el-form-item>
      
<!-- 
      <el-form-item label="活动首页轮播图：" prop="image">
        <div class="draggable-list"  >
          <draggable class="wrapper" v-model="form.image">
            <span>
              <div class="item" v-for="(item,index) in form.image" :key="item">
                <img v-img-url="item" />
                <a href="javascript:void(0);" class="delete-btn" @click="deleteImg(index)"><i class="el-icon-close"></i></a>
              </div>
            </span>
          </draggable>
          <div class="item img-select" @click="openProductUpload"><i class="el-icon-plus"></i></div>
        </div>
      </el-form-item> -->

    </el-form>

    
    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
    </div>

    <Upload v-if="isAboutLogoUpload" :config="{ total: 9 }" :isupload="isAboutLogoUpload" @returnImgs="returnLogoImgsFunc">上传图片</Upload>
 
    <Setlink
      v-if="is_linkset"
      :is_linkset="is_linkset"
      @closeDialog="closeLinkset"
      >选择链接</Setlink>

    <!--商品图片组件-->
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
  </div>
</template>
<script>
import activityApi from '@/api/activity.js';
import Upload from '@/components/file/Upload';
import draggable from 'vuedraggable';
import Setlink from "@/components/setlink/Setlink";
export default {
  components: {
    Upload,
    draggable,
    Setlink
  },
  data() {
    return {
      form: {
        is_activity: false,
        image:[],
        invite_price:0,
        cj_price:0,
        ban:[]
      },
      setting: [],
      loading: false,
      isProductUpload:false,
      isVideoUpload: false,
      isAboutLogoUpload:false,
      cindex:0,
      image_index:0,
      is_linkset:false,
    };
  },
  created() {
    /*获取列表*/
    this.getSetting();
  },
  methods: {
           /*选择链接*/
           changeLink(index) {
      this.is_linkset = true;
      this.image_index = index
    },
        /*获取链接并关闭弹窗*/
        closeLinkset(e) {
          this.is_linkset = false
          if (e) {
            this.form.ban[this.image_index].linkUrl = e.url;
            this.form.ban[this.image_index].linkName = "链接到" + " " + e.type + " " + e.name;
            this.form.ban[this.image_index].type = e.type 
          }
    },
    addBan(code=""){
    console.log('this.form.ban',this.form.ban)
  this.form.ban.push({
    file_path:"",
    linkUrl:"",
    linkName:"",
    type:""
  });
  this.$forceUpdate()

},
delBan(index){//删除广告
  this.form.ban.splice(index, 1);
  this.$forceUpdate()
},
    /*获取设置*/
    getSetting() {
      let self = this;
      let Params = {};
      activityApi.getSetting(Params, true)
        .then(data => {
          self.loading = false;
          console.log(data)
          if(data.data.vars.values!='[]'){
            self.form = data.data.vars.values;
          }

          if(!self.form.ban){
            self.form.ban =[];
          }
          
        })
        .catch(error => {});
    },
    /*点击保存*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      activityApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
            self.getSetting();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*打开上传图片*/
    openProductUpload: function() {
      this.isProductUpload = true;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      let self = this;
      if (e != null) {
        e.forEach(element => {
          console.log(element)
          self.form.image.push(element.file_path);
        });
      }
      self.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index) {
      let self = this;
      self.form.image.splice(index, 1);
      console.log(self.form.image);
    },
    selectImage(index){
      this.image_index = index;
      
      this.isAboutLogoUpload = true
    },
        // 上传logo图片
        returnLogoImgsFunc(e) {
      if (e != null) {
        let imgExpt = ['bmp', 'jpg', 'jpeg', 'png', 'gif']
        let prevent = false
        e.forEach((element) => {
          let data_array = element.file_path.split('.')
          let ext = data_array[data_array.length - 1]
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          })
        })
        if (!prevent) {
          this.$message.error('图片类型有误,请选择正确的图片格式')
          return false
        }
        this.form.ban[this.image_index].file_id = e[0].file_id
        this.form.ban[this.image_index].file_path = e[0].file_path
      }
      this.isAboutLogoUpload = false
    },
  }
};
</script>

<style>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/activity/setting/getSetting.vue